import React from 'react';
import _ from 'lodash';

import LTIPageProvider, { PageContext as LTIPageContext } from 'pages/CourseDashboard/LTI/PageProvider';
import PasswordPageProvider, { PageContext as PasswordPageContext } from 'pages/CourseDashboard/Password/PageProvider';

const isLTI = process.env.REACT_APP_AUTH === 'LTI';
const PageContext = isLTI ? LTIPageContext : PasswordPageContext;

const PageProvider = ({ children }) => {
    return isLTI ? (
        <LTIPageProvider>{children}</LTIPageProvider>
    ) : (
        <PasswordPageProvider>{children}</PasswordPageProvider>
    );
};
export { PageContext };
export default PageProvider;
